const { getAppSettings } = require("../user");

const EMPTY_OBJECT = {};
const firstNonEmpty = (objects = []) => {
	const object = objects.find(o => (o && typeof o === 'object' && Object.keys(o).length > 0));
	return object || EMPTY_OBJECT;
}

/**
 * IN APP REPORTS
 */
export const hasSettingEnableActionPlan = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.enableActionPlan;
};

export const hasSettingEnableClosureReport = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.enableClosureReport;
};


/**
 * TABS & LISTS PAGE - LINE LISTS
 */

export const hasSettingEnableLinesListCardsView = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return (
		_appSettings.enableLinesListCardsView ||
		(!_appSettings.enableLinesListCardsView && !_appSettings.enableLinesListTableView)
	);
};

export const hasSettingEnableLinesListTableView = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.enableLinesListTableView;
};

export const hasSettingEnableMyProjects = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.enableMyProjects;
};



/**
 * TABS & LISTS PAGE - REPORTS LIST
 */

export const hasSettingEnableReportPercentPassing = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.enableReportPercentPassing;
};

export const hasSettingEnableReportTotalMiles = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.enableReportTotalMiles;
};

export const hasSettingEnableReportListActionPlanAndClosureV1 = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return (
		(_appSettings.enableReportListActionPlanAndClosureV1 ||
			(
				!_appSettings.enableReportListActionPlanAndClosureV1 &&
				!_appSettings.enableReportListActionPlanAndClosureV2
			)
		) && (
			(
				_appSettings.enableActionPlan ||
				_appSettings.enableClosureReport
			)
		)
	);
};

export const hasSettingEnableReportListActionPlanAndClosureV2 = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.enableReportListActionPlanAndClosureV2 && (
		_appSettings.enableActionPlan ||
		_appSettings.enableClosureReport
	);
};

export const hasSettingEnableReports = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return (
		_appSettings.enableReportPercentPassing ||
		_appSettings.enableReportTotalMiles ||
		hasSettingEnableReportListActionPlanAndClosureV1(_appSettings) ||
		hasSettingEnableReportListActionPlanAndClosureV2(_appSettings)
	)
}



/**
 * MISCELLANEOUS SETTINGS
 */

export const hasSettingEnableSharedStateForAnalysisAndReports = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.enableSharedStateForAnalysisAndReports;
}

export const hasSettingAutoRemoveIliData = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.autoRemoveIliData;
};

export const hasSettingEnablePsqlIliData = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.enablePsqlIliData;
}

export const hasSettingEnableTempUploadAutoRemove = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.enableTempUploadAutoRemove;
}

export const hasSettingEnablePersistLinkedSurveys = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.enablePersistLinkedSurveys;
}

export const hasSettingFeatureClosureCopyActionPlan = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.featureClosureCopyActionPlan;
}




/**
 * CUSTOMER CREATED JOBS
 */

export const hasSettingEnableCustomerCreatedJobs = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return _appSettings.enableCustomerCreatedJobs && hasSettingEnableSharedStateForAnalysisAndReports(appSettingsOverride);
}

export const hasSettingDefaultUploadsToSearchable = (appSettingsOverride) => {
	const _appSettings = firstNonEmpty([appSettingsOverride, getAppSettings('SCANLINE')]);
	return hasSettingEnableCustomerCreatedJobs(_appSettings) && _appSettings.defaultUploadsToSearchable;
}



/**
 * UPLOAD SETTINGS - derived - simplifying selectors names
 */

export const blnHasSharedState = (appSettingsOverride) => {
	return hasSettingEnableSharedStateForAnalysisAndReports(appSettingsOverride);
}

export const blnAutoRemoveILIUploads = (appSettingsOverride) => {
	return hasSettingAutoRemoveIliData(appSettingsOverride);
}

export const blnAllowTemporaryUploads = (appSettingsOverride) => {
	return hasSettingEnableTempUploadAutoRemove(appSettingsOverride);
}

export const blnAllowSearchableUploads = (appSettingsOverride) => {
	return blnHasSharedState(appSettingsOverride) && hasSettingEnableCustomerCreatedJobs(appSettingsOverride);
}

export const blnDefaultUploadsToSearchable = (appSettingsOverride) => {
	return blnAllowSearchableUploads(appSettingsOverride) && hasSettingDefaultUploadsToSearchable(appSettingsOverride);
}


/**
 * COMPUTE USER OR COMPANY KEY - used in S3 paths as a differentiator for the path - if shared state is enabled, returns company name else userid
 */

export const settingsPickCorrectKeyForS3 = (appSettingsOverride, { userid, customerName }) => {
	const customerHasSharedStateEnabled = hasSettingEnableSharedStateForAnalysisAndReports(appSettingsOverride);
	if (customerName && customerHasSharedStateEnabled) {
		return customerName;
	}
	return userid;
}


export default {
	// IN APP REPORTS
	hasSettingEnableActionPlan,
	hasSettingEnableClosureReport,

	// TABS & LISTS PAGE - LINE LISTS
	hasSettingEnableLinesListCardsView,
	hasSettingEnableLinesListTableView,
	hasSettingEnableMyProjects,

	// TABS & LISTS PAGE - REPORTS LIST
	hasSettingEnableReportPercentPassing,
	hasSettingEnableReportTotalMiles,
	hasSettingEnableReportListActionPlanAndClosureV1,
	hasSettingEnableReportListActionPlanAndClosureV2,
	hasSettingEnableReports,

	// CUSTOMER CREATED JOBS
	hasSettingEnableCustomerCreatedJobs,
	hasSettingDefaultUploadsToSearchable,

	// MISCELLANEOUS SETTINGS
	hasSettingEnableSharedStateForAnalysisAndReports,
	hasSettingAutoRemoveIliData,
	hasSettingEnablePsqlIliData,
	hasSettingEnableTempUploadAutoRemove,
	hasSettingEnablePersistLinkedSurveys,
	hasSettingFeatureClosureCopyActionPlan,

	// UPLOAD SETTINGS - derived - simplifying selectors names
	blnHasSharedState,
	blnAutoRemoveILIUploads,
	blnAllowTemporaryUploads,
	blnAllowSearchableUploads,
	blnDefaultUploadsToSearchable,

	// COMPUTE USER OR COMPANY KEY - used in S3 paths as a differentiator for the path - if shared state is enabled, returns company name else userid
	settingsPickCorrectKeyForS3,
}
